import React from "react";
import FormComplains from "../components/form/formComplaints";
import "../styles/queriesComplaints.css";
import NavbarFrancaHealth from "../components/navbar/navabarFranca";
import NavbarFrancaPQR from "../components/navbar/navbarFrancaPQR";

const QuerieComplaints = () => {
  return (
    <>
      <NavbarFrancaPQR
        logo={
          <img
            src="/assets/Logos/FRANCA_landing_page_logos_health.png"
            alt="Logo health"
            width={150}
            height={80}
          />
        }
      />
      <div className="queriesComplaintsContainer">
        <div className="queriesComplaintsContainer_text">
          <h1 className="queriesComplaintsContainer_text_title">
            Mecanismo de reclamaciones y dudas: FRANCA® Agency
          </h1>

          <article>
            Si tienes alguna duda, comentario o denuncia sobre Franca Agency y
            los productos y/o servicios que la agencia publicita, no dudes en
            escribirnos a través del siguiente formulario:
          </article>

          <p>
            *El tiempo de respuesta de tu solicitud, comentario o denuncia será
            de 10 a 15 días hábiles dependiendo de su gravedad y las áreas
            encargadas de darle seguimiento al caso.
            <br />
            <br />
            *La respuesta será enviada al correo electrónico registrado en
            nuestro sistema de reclamaciones y dudas.
          </p>
        </div>
        <div className="queriesComplaintsContainer_form">
          <FormComplains />
        </div>
      </div>
    </>
  );
};

export default QuerieComplaints;
